module.exports = __webpack_public_path__ + "static/media/2.Diesel Generators.6341ba96.jpeg";